<template>
  <div>
    <v-snackbar
      :value="toast"
      :color="color"
      :multi-line="mobile"
      :vertical="mobile"
      :timeout="-1"
    >
    {{ message }}
    
    <v-btn
      text
      @click="closeToast"
    >
      Close
    </v-btn>
  </v-snackbar>
  </div>
</template>
<script>

import { Toaster } from '@/gql'
import { mergeToaster } from '@/js/apollo/'
export default {
  name: 'app-toast',
  beforeUpdate ()  {
    // cant use the regular timeout as we need to update state
    if(this.toast) {
      setTimeout (()=>{
        this.closeToast ();
      }, this.timeout);
    }
  },
  computed: {
    mobile () {
      return this.Toaster.mobile
    },
    toast () {
      return this.Toaster.showToaster
    },
    color () {
      return this.Toaster.color
    },
    message () {
      return this.Toaster.message
    },
    header () {
      return this.Toaster.header
    }
  },
  methods: {
    closeToast () {
      mergeToaster({ showToaster: false })
    }
  },
  data: () => {
    return {
      Toaster: {},
      timeout: 6000
    }
  },
  apollo: {
    Toaster () {
      return {
        query: Toaster
      }
    }
  }
}
</script>
